import { makeAutoObservable } from 'mobx';

class KZViewStore {
    constructor(model) {
        this.model = model;
        makeAutoObservable(this, {
            model: false
        });
    }

    get isKZ() {
        return !window.isRuDomain;
    }

    get isKZNonAuthorized() {
        const { isAuthenticated } = this.model.user;
        return (this.isKZ && !isAuthenticated)
    }

    kzNotEnoughBalance = (price) => {
        const { isAuthenticated, user } = this.model.user;
        const { balance } = user;
        return this.isKZ && isAuthenticated && +price > +balance;
    }

    get showBalanceInSummary() {
        const { isAuthenticated, user } = this.model.user;
        const { balance } = user;
        return !this.isKZ && isAuthenticated && balance > 0
    }
}

export default KZViewStore;
